import { Typography, Box } from '@mui/material';
import { ArrowBackIosNewRounded as ArrowBackIosNewRoundedIcon, ArrowForwardIosRounded as ArrowForwardIosRoundedIcon } from "@mui/icons-material";

interface MonthPickerProps {
  month: string;
  handleBack: () => void;
  handleForward: () => void;
  disableBack?: boolean;
  disableForward?: boolean;
}

const MonthPicker = (props: MonthPickerProps) => {

  return props.month ? (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {!props.disableBack && (
        <ArrowBackIosNewRoundedIcon
          sx={{
            stroke: "#14142B",
            strokeWidth: 1,
            height: 12,
            width: 12,
            cursor: "pointer",
          }}
          onClick={props.handleBack}
        />
      )}
      <Typography 
        style={{ 
          fontFamily: "Work Sans", 
          fontStyle: "normal", 
          fontWeight: 600, 
          fontSize: "18px", 
          lineHeight: "22px", 
          color: "#14142B", 
          margin: "0 5px",
        }}
      >
        {props.month}
      </Typography>
      {!props.disableForward && (
        <ArrowForwardIosRoundedIcon
          sx={{
            stroke: "#14142B",
            strokeWidth: 1,
            height: 12,
            width: 12,
            cursor: "pointer",
          }}
          onClick={props.handleForward}
        />
      )}
    </Box>
  ) : (
    <></>
  )
}

export default MonthPicker;
